/* Widget « Suivre cette rubrique » (archive éditoriale de catégorie). */

/* Le widget est un APPEL À L'ACTION, pas un bout de formulaire : sans enveloppe
   il flottait sous l'introduction, cases à cocher et bouton en vrac. Une carte
   discrète le pose comme un bloc voulu, sans concurrencer le titre de page. */
.gas-topic-follow {
    margin: var(--gas-space-l) 0;
    padding: var(--gas-space-m);
    border: 1px solid var(--gas-color-border);
    border-radius: var(--gas-radius-l);
    background: var(--gas-color-surface-muted);
    max-width: 560px;
}

.gas-topic-follow__inner {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-3);
    align-items: flex-start;
}

/* Intitulé du bloc, au-dessus des canaux. */
.gas-topic-follow__heading {
    /* <legend> dans un conteneur flex : le sortir du flux d'items en lui donnant
       toute la largeur, sinon il s'aligne comme une colonne à côté des cases. */
    flex-basis: 100%;
    float: none;
    padding: 0;
    margin: 0 0 var(--gas-space-2);
    font-size: var(--gas-text-m);
    font-weight: 600;
    color: var(--gas-color-text);
}

/* Les canaux tiennent sur une ligne : deux cases à cocher empilées prenaient
   autant de hauteur que le reste du bloc pour deux mots. */
.gas-topic-follow__channels {
    /* Un <fieldset> se dimensionne sur son contenu minimal : sans width:100% il
       restait à 190px et les deux canaux (210px) passaient à la ligne. */
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-3) var(--gas-space-l);
    align-items: center;
    margin: 0;
    padding: 0;
    border: 0;
}

.gas-topic-follow__channel {
    display: inline-flex;
    align-items: center;
    gap: var(--gas-space-2);
    white-space: nowrap;
}

.gas-topic-follow__channels-hint {
    flex-basis: 100%;
    margin: 0;
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-s);
}

@media (max-width: 480px) {
    .gas-topic-follow__channels { flex-direction: column; align-items: flex-start; gap: var(--gas-space-2); }
}

.gas-topic-follow__title {
    margin: 0;
    font-weight: 600;
    color: var(--gas-color-success);
}

.gas-topic-follow__hint {
    margin: 0;
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-s);
}

.gas-topic-follow__form {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-3);
    width: 100%;
    max-width: 448px;
}

.gas-topic-follow__fields {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-2);
}

.gas-topic-follow__field {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-1);
    font-size: var(--gas-text-s);
    text-align: left;
}

.gas-topic-follow__field input {
    padding: var(--gas-space-2) var(--gas-space-3);
    border: 1px solid var(--gas-color-border);
    border-radius: var(--gas-radius-s);
    background: var(--gas-color-surface);
    color: var(--gas-color-text);
    font-size: var(--gas-text-s);
}

.gas-topic-follow__field input:focus-visible {
    outline: 2px solid var(--gas-color-primary);
    outline-offset: 1px;
}

/* NB : la mise en forme des canaux (ligne unique, largeur pleine) est définie
   plus haut avec la carte. Ne pas la redéfinir ici — deux blocs concurrents,
   le second gagnait et remettait les canaux en colonne. */
.gas-topic-follow__channel {
    font-size: var(--gas-text-s);
    color: var(--gas-color-text);
}

.gas-topic-follow__actions {
    display: flex;
    gap: var(--gas-space-3);
    flex-wrap: wrap;
    align-items: center;
}

.gas-topic-follow__count {
    margin: 0;
    font-size: var(--gas-text-s);
    color: var(--gas-color-text-muted);
}

.gas-topic-follow__error {
    margin: 0;
    color: var(--gas-color-danger);
    font-size: var(--gas-text-s);
}

.gas-topic-follow__info {
    margin: 0;
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-s);
}

.gas-topic-follow__followed {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-2);
    align-items: flex-start;
}

.gas-topic-follow__fallback {
    margin: 0;
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-s);
}

/* Invité en attente de confirmation : ni « abonné », ni rien — un état à part. */
.gas-topic-follow__pending {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--gas-space-xs, 6px);
}

.gas-topic-follow__cta {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-3);
    align-items: flex-start;
}
